module.exports = "<img [src]=\"imagePath\" [alt]=\"imageAlt\" height=\"24px\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/logo-bandeira/logo-bandeira.component.html
// module id = ./src/app/common/logo-bandeira/logo-bandeira.component.html
// module chunks = main